import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import UserDetails from './submodules/userDetails';
import ListUserSegments from './submodules/listUserSegments';

const GetUserSegmentDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getUserDetails]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/getUserDetails`}
				component={UserDetails}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/getUserDetails/listUserSegments`}
				component={ListUserSegments}
				exact
			/>
			<Redirect to={`${path}/getUserDetails`} />
		</Switch>
	);
};

export default GetUserSegmentDashboard;
